import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';

import { AzureDevOpsAgentPoolPicker } from './AzureDevOpsAgentPoolPicker';

export const AzureDevOpsAgentPoolPickerFieldExtension = FormFieldBlueprint.make(
  {
    name: 'azure-devops-agent-pool-picker',

    params: {
      field: async () =>
        createFormField({
          name: 'AzureDevOpsAgentPoolPicker',
          component: AzureDevOpsAgentPoolPicker,
        }),
    },
  },
);
